import React from 'react'

const RightAboutParaSection2 = (props) => {
  return (
    <p className="mt-6 cursor-pointer text-xl text-slate-800 hover:text-blue-400 ">
    {props.para}
  </p>
  )
}

export default RightAboutParaSection2